"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
// eslint-disable-next-line
exports.zh_cn = {
    locale: 'zh_cn',
    // 操作：确定按钮
    resetText: ('重置'),
    // 暂无数据
    noData: ('暂无数据'),
};
//# sourceMappingURL=zh_cn.js.map